import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
const routes: Routes = [
  { path: '', loadChildren: () => import('./pages/onboarding/onboarding.module').then(m => m.OnboardingPageModule) },
  // { path: 'home', loadChildren: './pages/home/home.module#HomePageModule' },
  { path: 'onboarding', loadChildren: () => import('./pages/onboarding/onboarding.module').then(m => m.OnboardingPageModule) },
  { path: 'tabs', loadChildren: () => import('./pages/tabs/tabs.module').then(m => m.TabsPageModule) },
  { path: 'register', loadChildren: () => import('./pages/register/register.module').then(m => m.RegisterPageModule) },
  { path: 'select', loadChildren: () => import('./pages/select/select.module').then(m => m.SelectPageModule) },
  { path: 'login', loadChildren: () => import('./pages/login/login.module').then(m => m.LoginPageModule) },
  { path: 'welcome', loadChildren: () => import('./pages/welcome/welcome.module').then(m => m.WelcomePageModule) },
  { path: 'checkin', loadChildren: () => import('./pages/checkin/checkin.module').then(m => m.CheckinPageModule) },
  { path: 'gift', loadChildren: () => import('./pages/gift/gift.module').then(m => m.GiftPageModule) },
  { path: 'categories', loadChildren: () => import('./pages/categories/categories.module').then(m => m.CategoriesPageModule) },
  {
    path: 'conseil',
    children: [
      {
        path: ':id',
        children: [
          {
            path: '',
            loadChildren: () => import('./pages/conseil/conseil.module').then(m => m.ConseilPageModule)
          },
          {
            path: ':back',
            loadChildren: () => import('./pages/conseil/conseil.module').then(m => m.ConseilPageModule)
          }
        ]
      }
    ]
  },
  { path: 'keys', loadChildren: () => import('./pages/keys/keys.module').then(m => m.KeysPageModule) },

];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
